<h2>Passwortänderung</h2>
@if (['edit', 'validating'].includes(this.state)) {
  <form class="m-5" novalidate [formGroup]="form" (ngSubmit)="submit(form.value)">
    <div class="mb-3">
      <!--<input placeholder="Passwort" type="password" class="form-control" formControlName="password">-->
      <gea-shop-password-input placeholder="Passwort" formControlName="password" />
      <show-form-error text="Passwort" path="password"></show-form-error>
    </div>
    <div class="mb-3">
      <!--<input placeholder="Passwort Wiederholung" type="password" class="form-control" formControlName="confirmPassword">-->
      <gea-shop-password-input placeholder="Passwort Wiederholung" formControlName="confirmPassword" />
      <show-form-error text="Passwort Wiederholung" path="confirmPassword"></show-form-error>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="! form.valid">Passwort ändern</button>
  </form>
}
@if (this.state == 'validating') {
  <div class="mb-3"><p>Bitte warten, das Passwort wird geändert...</p></div>
}
@if (this.state == 'fail') {
  <div class="mb-3"><p>Das Passwort konnte leider nicht geändert werden. Bitte wende dich an den GEA-Kundenservice.</p></div>
}
@if (this.state == 'success') {
  <div class="mb-3"><p>Das Passwort wurde erfolgreich geändert!</p></div>
}
